export default __webpack_public_path__ + "static/media/8.d9e9441f.jpg";